import { observer } from "mobx-react"
import React from "react"
import AIModalJson from "../../Configs/JSON/MobileModal.json"
import FormStore from "../../Configs/Store/forms"
import "../../styles/calculator/AnnualIncomeModal.less"
import CircleIcon from "../Common/CircleIcon"
import GenericModal from "../Common/GenericModal"

const MobileModal = observer(() => {
  return (
    <>
      <GenericModal
        visibleState={FormStore.calc_mobModal}
        updateVisibility={() => FormStore.setMobileModal(false)}
        closeIcon={<CircleIcon iconUrl={"common/Iconionic-md-close-circle-outline"} />}
        rootClassAntCustom={"AnnualIncomeModal"}
        showButton={true}
        buttonText={AIModalJson["buttonText"]}
        // buttonStyle={"OKButton"}
        buttonWrapper={"calculateFormDiv"}
        buttononClick={() => FormStore.setMobileModal(false)}
        component={
          <div className="contentWrap">
            <CircleIcon iconStyle="titleICon" iconUrl={AIModalJson["mainIcon"]} />
            <div className="SectionTitle">{AIModalJson["modalTitle"]}</div>
            <div className="content">{AIModalJson["modalContent"]}</div>
          </div>
        }
      />
    </>
  )
})

export default MobileModal
